<ng-container *transloco="let t; read: 'orders'">

  <span class="orderPositionTitle">{{ t("orderPositions.title") }}</span>

  <kendo-grid
    [data]="orderPositions"
    [rowClass]="rowClass">

    <!-- DESKTOP GRID -->
    <kendo-grid-column
      field="product.internalNumber"
      [title]="t('product.internalNumber')"
      media="(min-width: 993px)">
    </kendo-grid-column>

    <kendo-grid-column
      field="product.name"
      [title]="t('product.name')"
      media="(min-width: 993px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.product?.name}}
        @if (!dataItem.product?.isActive && dataItem.product?.inactiveReason) {
          <span class="tooltipContainer">
            <span [attr.tooltip]="dataItem.product.inactiveReason" flow="right" class="tooltipContainer">
              <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
            </span>
          </span>
        }
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="quantity"
      [title]="t('product.quantity')"
      media="(min-width: 993px)">
    </kendo-grid-column>

    <kendo-grid-column
      field="location"
      [title]="t('product.location')"
      media="(min-width: 993px)">
    </kendo-grid-column>

    <!-- MOBILE GRID -->
    <kendo-grid-column media="(max-width: 992px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <h4 class="mobileGridHeader">{{t('orderNumber')}}</h4>
        <span>{{dataItem.product.internalNumber}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(max-width: 992px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <h4 class="mobileGridHeader">{{t('product.name')}}</h4>
        <span>{{dataItem.product.name}}</span>
        @if (!dataItem.product?.isActive && dataItem.product?.inactiveReason) {
          <span class="tooltipContainer">
            <span [attr.tooltip]="dataItem.product.inactiveReason" flow="right" class="tooltipContainer">
              <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
            </span>
          </span>
        }
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(max-width: 992px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <h4 class="mobileGridHeader">{{t('product.quantity')}}</h4>
        <span>{{dataItem.quantity}}</span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(max-width: 992px)">
      <ng-template kendoGridCellTemplate let-dataItem>
        <h4 class="mobileGridHeader">{{t('product.location')}}</h4>
        <span>{{dataItem.location}}</span>
      </ng-template>
    </kendo-grid-column>

    <!-- IF NO RESULTS COULD BE FOUND -->
    <ng-template kendoGridNoRecordsTemplate>
      <div class="text pl">{{ t("noResults") }}</div>
    </ng-template>

  </kendo-grid>

</ng-container>
